import {useEffect} from 'react';
import {
    showTalkMeWidget,
    hideTalkMeWidget,
    setTalkMeClientInfo,
    initTalkMeChat,
    isWidgetAvailable
} from './talkme';
import {IUser} from '@app/user';
import {ClientDetails} from '@app/interfaces/ClientDetails';

export function useTalkMe(user: IUser | undefined, clientDetails: ClientDetails | undefined) {
    useEffect(() => {
        if (isWidgetAvailable()) {
            initTalkMeChat(user?.login);

            setTalkMeClientInfo(
                user?.displayName,
                user?.clientName,
                user?.login,
                clientDetails?.mrk?.name,
                (error) => {
                    if (error) {
                        console.error('TalkMe setClientInfo error:', error);
                    }
                }
            );
            showTalkMeWidget();
        } else {
            hideTalkMeWidget();
        }

        return () => hideTalkMeWidget();
    }, [
        user?.login,
        user?.displayName,
        user?.clientName,
        clientDetails?.mrk?.name
    ]);
}
